// extracted by mini-css-extract-plugin
module.exports = {"actionIcon":"NavbarButtonFeatureBase_actionIcon__P0150","icon":"NavbarButtonFeatureBase_icon__nPckY"};